import { Component, OnInit, input } from '@angular/core';

import { RegisterComponent } from '../../components/component-lookup';
import { FlexComponent } from '../flex-component/flex.component';

@RegisterComponent('FlexItem')
@Component({
  selector: 'app-flex-item',
  standalone: true,
  imports: [],
  templateUrl: './flex-item.component.html',
  styleUrl: './flex-item.component.scss',
  host: { class: 'flex__item', '[style.background-color]': 'background()', '[id]': 'tourId()' }
})
export class FlexItemComponent extends FlexComponent implements OnInit {
  background = input<string>('white');
  title = input<string>('');
  expandable = input<boolean>(false);
  expanded = input<boolean>(false);
  
  override ngOnInit(): void {
    super.ngOnInit();
  }
}
